import { Geometry } from 'geojson';

import { LimitPaginatedResponse } from '@/models/endpoint';

import { resolveV3 } from '../resolveV3';

export type SectionTownshipRange = {
  id: number;
  plssid: string;
  section: string;
  township: string;
  range: string;
  township_range: string;
  state_abbrev: string;
  geometry: Geometry;
};

export default function getSectionTownshipRange(
  {
    limit,
    offset = 0,
    includes__geometry = false,
    section_township_range__startswith,
    geometry__contains = undefined,
  }: {
    limit?: number;
    offset?: number;
    includes__geometry?: boolean;
    geometry__contains?: string;
    section_township_range__startswith?: string;
  },
  signal: AbortSignal
): Promise<LimitPaginatedResponse<SectionTownshipRange>> {
  const params = new URLSearchParams();
  if (includes__geometry) {
    params.set('include__geometry', 'true');
  }
  if (offset) {
    params.set('offset', offset.toString());
  }
  if (limit) {
    params.set('limit', limit.toString());
  }
  if (section_township_range__startswith) {
    params.set(
      'section_township_range__startswith',
      section_township_range__startswith
    );
  }
  if (geometry__contains) {
    params.set('geometry__contains', geometry__contains);
  }

  return resolveV3(
    {
      method: 'GET',
      params,
      signal,
      url: `/section-township-range/`,
    },
    {
      baseUrl: 'itasca',
    }
  );
}
